import React from "react";
import {
    Card,
    CardContent,
    CardMedia,
    Typography,
    Grid,
    Box,
    Chip,
    Divider,
    Button,
} from "@mui/material";
import ForumIcon from "@mui/icons-material/Forum";
import { useSelector } from "react-redux";
import { selectCurrentScope } from "../app/auth/authSlice";

export default function ForumPage({ forum }) {
    const memberScope = useSelector(selectCurrentScope);
    if (!forum) return null;
    return (
        <Box
            sx={{
                maxWidth: "1200px",
                margin: "0 auto"
            }}
        >
            {/* Header Section */}
            <Box
                sx={{
                    display: "flex",
                    alignItems: { md: "start", xs: 'center' },
                    mb: 3,
                    gap: 3,
                    flexDirection: { xs: "column", md: "row" },
                    textAlign: { xs: "center", md: "left" },
                }}
            >
                <ForumIcon color="primary" className="mt-1" sx={{ fontSize: 40 }} />
                <Box className='w-100'>
                    <Typography variant="h4" fontWeight="bold" sx={{
                        fontSize: {
                            xs: "1.25rem", // ~20px on extra-small screens
                            sm: "1.5rem",  // ~24px on small screens
                            md: "2.25rem",    // ~32px on medium+
                        },
                    }} className="mb-3">
                        {forum.headline}
                    </Typography>
                    <Box className="d-flex w-100" sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", mt: 0.5 }}>
                        <Typography variant="body2">
                            <b>Category:</b>{" "}
                            <Chip
                                label={forum?.categoryDetails?.categoryName}
                                size="small"
                                color="secondary"
                                sx={{ ml: 1 }}
                            />
                        </Typography>
                        <div className="d-flex align-items-center gap-3">
                            <Typography variant="body2">
                                <b>Posted on:</b>{" "}
                                {new Date(forum.createdAt).toLocaleDateString("en-IN")}
                            </Typography>
                            {(memberScope !== 'PORTAL_MEMBER' && window.location.pathname.includes('readMoreForum')) && <Typography variant="body2">
                                <b>Status:</b>{" "}
                                {forum.isApproved === 1 ? "Approved ✅" : forum.isApproved === 0 ? "Pending ⏳" : "Rejected ❌"}
                            </Typography>}
                        </div>
                    </Box>
                </Box>
            </Box>

            <Grid container spacing={3}>
                {/* Left Section (Forum Main Content) */}
                <Grid item xs={12}>
                    <Card
                        sx={{
                            borderRadius: 3,
                            boxShadow: 3,
                        }}
                    >
                        {forum.uploadImage && (
                            <Box
                                sx={{
                                    position: "relative",
                                    width: "100%",
                                    aspectRatio: "16/9", // maintains responsiveness
                                    borderTopLeftRadius: 12,
                                    borderTopRightRadius: 12,
                                    overflow: "hidden",
                                }}
                            >
                                <CardMedia
                                    component="img"
                                    image={forum.uploadImage}
                                    alt={forum.headline}
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                    }}
                                />
                            </Box>
                        )}
                        <CardContent>
                            <Typography
                                gutterBottom
                                variant="h5"
                                component="div"
                                fontWeight="bold"
                            >
                                {forum.name}
                            </Typography>

                            <Typography
                                variant="body1"
                                color="text.primary"
                                sx={{ whiteSpace: "pre-line", textAlign: "justify" }}
                            >
                                {forum.description}
                            </Typography>

                            <Divider sx={{ my: 2 }} />

                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexWrap: "wrap",
                                    gap: 1,
                                    alignItems: "center",
                                }}
                            >
                                <div className="d-flex gap-3 flex-wrap">
                                    <Typography variant="caption" color="text.secondary">
                                        Updated on:{" "}
                                        {new Date(forum.updatedDate).toLocaleDateString("en-IN")}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        Written By: {forum.createdBy?.role === 'PORTAL_SUPER_ADMIN' ? 'ELTAI' : forum.createdBy?.role === 'PORTAL_ADMIN' ? 'ELTAI' : forum.createdBy?.role === 'PORTAL_CHAPTER_ADMIN' ? 'Chapter Admin' : forum.createdBy?.role === 'PORTAL_SIG_ADMIN' ? 'SIG Admin' : forum.createdBy?.role === 'PORTAL_MEMBER' ? "Member" : 'Unknown'}
                                    </Typography>
                                </div>
                                {/* PDF Button in header */}
                                {forum.pdflink && (
                                    <Button
                                        href={forum.pdflink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        size="small"
                                        variant="outlined"
                                    >
                                        View PDF
                                    </Button>
                                )}
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                {/* Right Sidebar */}
                {/* <Grid item xs={12} md={4} >
                    <Card
                        sx={{
                            borderRadius: 3,
                            boxShadow: 2,
                            p: 2,
                            position: "sticky",
                            top: 100,
                        }}
                    >
                        <Typography
                            variant="h6"
                            fontWeight="bold"
                            gutterBottom
                            color="primary"
                        >
                            Forum Info
                        </Typography>
                        <Divider sx={{ mb: 2 }} />

                        <Typography variant="body2" gutterBottom>
                            <b>Category:</b> {forum.categoryDetails.categoryName}
                        </Typography>
                        {forum.categoryDetails.subCategory?.length > 0 && (
                            <Typography variant="body2" gutterBottom>
                                <b>Subcategory:</b>{" "}
                                {forum.categoryDetails.subCategory
                                    .map((sub) => sub.subCategoryName)
                                    .join(", ")}
                            </Typography>
                        )}
                        <Typography variant="body2" gutterBottom>
                            <b>Status:</b>{" "}
                            {forum.isApproved ? "Approved ✅" : "Pending ⏳"}
                        </Typography>
                    </Card>
                </Grid> */}
            </Grid>
        </Box>
    );
}
